/* === cp-filtros === */
  (function () {
    if (window.__cpFiltros) return;
    window.__cpFiltros = true;

    var ESPERA = 700; // ms que se le dan al tema antes de intervenir

    function urlDesde(form) {
      var p = new URLSearchParams();
      form.querySelectorAll('input[name^="filter."]').forEach(function (i) {
        if (i.type === 'checkbox' || i.type === 'radio') {
          if (i.checked) p.append(i.name, i.value);
        } else if (i.value !== '') {
          p.append(i.name, i.value);
        }
      });
      var orden = new URLSearchParams(window.location.search).get('sort_by');
      if (orden) p.set('sort_by', orden);
      var q = p.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }

    function huella() {
      return window.location.search + '|' + document.querySelectorAll('li.tag--remove').length;
    }

    // RESPALDO: no intercepta nada. Deja actuar al tema y solo entra si no paso nada.
    document.addEventListener('change', function (e) {
      var casilla = e.target.closest && e.target.closest('.filter-form input.tag__input');
      if (!casilla || !casilla.form) return;
      var antes = huella();
      var form = casilla.form;
      setTimeout(function () {
        if (huella() !== antes) return;   // el tema ya lo resolvio
        window.location.href = urlDesde(form);
      }, ESPERA);
    });

    // "Clear all": el tema no lo trae. Se repone cada vez que repinta la barra.
    function ponerLimpiar() {
      document.querySelectorAll('ul.tag-list--active-tags').forEach(function (ul) {
        if (!ul.querySelector('li.tag--remove')) return;
        if (ul.querySelector('.cp-limpiar')) return;
        var orden = new URLSearchParams(window.location.search).get('sort_by');
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'cp-limpiar';
        a.textContent = 'Clear all';
        a.href = window.location.pathname + (orden ? '?sort_by=' + encodeURIComponent(orden) : '');
        li.appendChild(a);
        ul.appendChild(li);
      });
    }

    function vigilar() {
      ponerLimpiar();
      var caja = document.getElementById('CollectionAjaxContent');
      if (!caja) return;
      new MutationObserver(function () { ponerLimpiar(); })
        .observe(caja, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', vigilar);
    } else {
      vigilar();
    }
  })();

/* === cp-filtros-estilo === */
  (function () {
    if (window.__cpFiltrosTexto) return;
    window.__cpFiltrosTexto = true;

    // El conteo " (n)" lo escribe el tema como texto suelto, sin clase, asi que
    // no se puede estilar. Se envuelve en un <span> para poder darle la pastilla.
    // Y en el filtro de tipo de producto se recorta el prefijo de familia:
    // "Pumps - Above-Ground Pump" se muestra como "Above-Ground Pump".
    function arreglar(raiz) {
      (raiz || document).querySelectorAll('.filter-form li.tag').forEach(function (li) {
        if (li.dataset.cpListo) return;
        var casilla = li.querySelector('input.tag__input');
        var texto = li.querySelector('.tag__text');
        if (!casilla || !texto) return;
        li.dataset.cpListo = '1';

        if (casilla.name === 'filter.p.product_type') {
          var partes = texto.textContent.split(' - ');
          if (partes.length > 1) texto.textContent = partes.slice(1).join(' - ').trim();
        }

        var envoltura = texto.parentNode;
        envoltura.childNodes.forEach && Array.prototype.slice.call(envoltura.childNodes).forEach(function (n) {
          if (n.nodeType !== 3) return;
          var m = n.textContent.match(/\((\d+)\)/);
          if (!m) return;
          var s = document.createElement('span');
          s.className = 'cp-conteo';
          s.textContent = m[1];
          envoltura.replaceChild(s, n);
        });
      });
    }

    function arrancar() {
      arreglar();
      var caja = document.getElementById('CollectionAjaxContent');
      if (!caja) return;
      new MutationObserver(function () { arreglar(); }).observe(caja, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }
  })();

/* === cp-align === */
  (function () {
    var CORTE = 769;

    function piezas() {
      var band = document.querySelector('[id*="__promo-tiles-band"]');
      var grid = document.querySelector('[id*="__best-sellers"]');
      if (!band || !grid) return null;
      var tile = band.querySelector('[class*="flex-grid__item--band"]') ||
                 band.querySelector('.flex-grid__item');
      if (!tile) return null;
      return { tile: tile, grid: grid };
    }

    function alinear() {
      var p = piezas();
      if (!p) return;
      if (window.innerWidth < CORTE) {
        p.tile.style.minHeight = '';
        p.tile.style.height = '';
        return;
      }
      var h = p.grid.offsetHeight;
      if (h > 0) {
        p.tile.style.minHeight = h + 'px';
        p.tile.style.height = h + 'px';
      }
    }

    function arrancar() {
      alinear();
      var p = piezas();
      if (p && window.ResizeObserver) {
        new ResizeObserver(alinear).observe(p.grid);
      }
      window.addEventListener('load', alinear);
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(alinear, 120);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }
    document.addEventListener('shopify:section:load', alinear);
  })();

  (function () {
    function igualarTitulos() {
      var filas = document.querySelectorAll('.text-with-icons__blocks');
      var apilado = window.matchMedia('(max-width: 768px)').matches;
      for (var i = 0; i < filas.length; i++) {
        var titulos = filas[i].querySelectorAll('.text-with-icons__block-title');
        if (titulos.length < 2) continue;
        for (var j = 0; j < titulos.length; j++) {
          titulos[j].style.minHeight = '';
        }
        if (apilado) continue;
        var max = 0;
        for (var k = 0; k < titulos.length; k++) {
          max = Math.max(max, titulos[k].getBoundingClientRect().height);
        }
        for (var m = 0; m < titulos.length; m++) {
          titulos[m].style.minHeight = Math.ceil(max) + 'px';
        }
      }
    }

    var t2;
    function programar() {
      clearTimeout(t2);
      t2 = setTimeout(igualarTitulos, 120);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', igualarTitulos);
    } else {
      igualarTitulos();
    }
    window.addEventListener('load', igualarTitulos);
    window.addEventListener('resize', programar);
    document.addEventListener('shopify:section:load', igualarTitulos);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(igualarTitulos);
    }
  })();

/* === cp-atc === */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cp-atc');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.disabled) return;
    var antes = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(b.getAttribute('data-variant-id')), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () {
      b.textContent = 'Added';
      // primero reconstruir, despues abrir: ver el comentario de arriba
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      document.dispatchEvent(new CustomEvent('cart:build'));
      var icono = document.querySelector('#HeaderCartTrigger, .js-drawer-open-cart, .site-nav__link--cart, a[href="/cart"]');
      if (icono) icono.click();
      setTimeout(function () { b.textContent = antes; b.disabled = false; }, 1600);
    }).catch(function () {
      b.textContent = 'Try again';
      b.disabled = false;
    });
  });
})();
